import { useRootEditActions } from '@/components/provider/RootEditProvider/RootEditProvider.context';

export const useSafeUiAction = () => {
    const { guardUiAction } = useRootEditActions();

    return {
        openServiceMenu: (fn: () => void) => guardUiAction('SERVICE_MENU', fn),
        openNavMenu: (fn: () => void) => guardUiAction('NAV_MENU', fn),
    };
};
